/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Add_PillInputs */



/**
* | output |
* | --- |
* | "Wundo" |
*
* @param {Agenda_Add_PillInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_add_pill = /** @type {((inputs?: Agenda_Add_PillInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Add_PillInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo")
	return /** @type {LocalizedString} */ ("Wundo")
});